import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface WebState {
	url: string | null;
	error: string | null;
}

const initialState: WebState = {
	url: null,
	error: null,
};

const webSlice = createSlice({
	name: "web",
	initialState,
	reducers: {
		setUrl: (state, action: PayloadAction<string>) => {
			state.url = action.payload;
			state.error = null;
		},
		clearUrl: (state) => {
			state.url = null;
		},
		setError: (state, action: PayloadAction<string | null>) => {
			state.error = action.payload;
		},
		clearError: (state) => {
			state.error = null;
		},
	},
});

export const { setUrl, clearUrl, setError, clearError } = webSlice.actions;
export default webSlice.reducer;
